<template>
  <!-- Alcance del proyecto: texto libre manual (sin fuente). Clic para editar; Esc cancela, Ctrl+Enter guarda.
       Reutilizable: acepta titulo/hint/placeholder propios y un modo solo-lectura (p. ej. eco en el Dashboard). -->
  <summary-card :title="cardTitle" :mode="mode" :mark="true" chip="none">
    <template #icon><b-icon pack="fas" icon="bullseye" size="is-small"></b-icon></template>
    <template #extra><span class="hint">{{ cardHint }}</span></template>

    <div class="scope-body">
      <template v-if="editing && !readonly">
        <textarea ref="ta" v-model="draft" class="scope-input" :placeholder="cardPlaceholder"
          @keydown.esc="cancel" @keydown.enter="onEnter"></textarea>
        <div class="scope-actions">
          <button class="btn-save" @click="commit">{{ $t('save') }}</button>
          <button class="btn-cancel" @click="cancel">{{ $t('cancel') }}</button>
        </div>
      </template>
      <div v-else class="scope-view" :class="{ ro: readonly }" @click="edit">
        <p v-if="scope" class="scope-text">{{ scope }}</p>
        <p v-else class="scope-empty">{{ cardPlaceholder }}</p>
        <i v-if="!readonly" class="fas fa-pencil scope-pencil"></i>
      </div>
    </div>
  </summary-card>
</template>

<script>
  import SummaryCard from '../summary/summary-card.vue'

  export default {
    name: 'PrmDashScope',

    components: { SummaryCard },

    props: {
      scope: { type: String, default: '' },
      mode: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false }, // eco solo-lectura (p. ej. en el Dashboard)
      title: { type: String, default: '' }, // titulo propio; si vacio usa el del Dashboard
      hint: { type: String, default: '' }, // hint propio; si vacio usa el del Dashboard
      placeholder: { type: String, default: '' }, // placeholder propio; si vacio usa el del Dashboard
    },

    data () {
      return { editing: false, draft: '' }
    },

    computed: {
      cardTitle () { return this.title || this.$t('prm_dash_scope_title') },
      cardHint () { return this.hint || this.$t('prm_dash_scope_hint') },
      cardPlaceholder () { return this.placeholder || this.$t('prm_dash_scope_placeholder') },
    },

    methods: {
      edit () {
        if (this.readonly) return
        this.draft = this.scope || ''
        this.editing = true
        this.$nextTick(() => this.$refs.ta && this.$refs.ta.focus())
      },
      commit () {
        this.editing = false
        if (this.draft !== (this.scope || '')) this.$emit('save', this.draft)
      },
      // Enter inserta salto de línea; solo Ctrl/Cmd+Enter guarda.
      onEnter (e) {
        if (e.ctrlKey || e.metaKey) { e.preventDefault(); this.commit() }
      },
      cancel () { this.editing = false },
    },
  }
</script>

<style lang="scss" scoped>
  .hint { margin-left: auto; font-size: 9px; font-weight: 400; text-transform: none; color: #9aa4b2; }
  .scope-body { padding: 10px; }

  .scope-view { display: flex; align-items: flex-start; gap: 8px; cursor: text; }
  .scope-view.ro { cursor: default; }
  .scope-text { font-size: 12px; color: #2c3a4d; line-height: 1.5; white-space: pre-wrap; flex: 1; }
  .scope-empty { font-size: 12px; color: #9aa4b2; font-style: italic; flex: 1; }
  .scope-pencil { font-size: 11px; color: #b7791f; opacity: 0; transition: opacity .1s; margin-top: 2px; }
  .scope-view:hover .scope-pencil { opacity: 1; }

  .scope-input {
    width: 100%; min-height: 84px; resize: vertical; font-size: 12px; color: #2c3a4d; line-height: 1.5;
    border: 1px solid #e0b52a; border-radius: 6px; background: #fffdf4; padding: 8px 10px; outline: none;
    box-shadow: 0 0 0 2px rgba(224, 181, 42, .12);
  }
  .scope-actions { margin-top: 8px; display: flex; gap: 6px; }
  .btn-save, .btn-cancel {
    font-size: 11px; font-weight: 600; padding: 4px 12px; border-radius: 6px; cursor: pointer; border: 1px solid;
  }
  .btn-save { color: #1e6b3d; background: #eef7f0; border-color: #a9d0b4; }
  .btn-save:hover { background: #e2efe7; }
  .btn-cancel { color: #c0392b; background: #fdf2f0; border-color: #e6b8b2; }
  .btn-cancel:hover { background: #f8e6e2; }
</style>
